import React from 'react';
import styles from './styles.module.scss';
import { formatGameMode, formatResult } from '@profile/src/Profile_V2/Components/Ingame/Components/BattleRewards/utils';
import classnames from 'classnames';
import icTHC from 'assets/img/thetan_coin_V2.png';
import icGPP from 'assets/img/power_point_V2.png';
import icEXP from 'assets/img/ic_exp.png';
import { formatDateTimeByTimestamp } from '@profile/src/utils/date';

const TableDesktopItem = ({
  battle
}) => {
  const renderResult = (result, rank, gameMode) => {
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.result, styles[formatResult(result)])
    }, /*#__PURE__*/React.createElement("span", null, `${formatResult(result)}${gameMode === 1 || gameMode === 2 ? ' #' + rank : ''}`));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.cell
  }, /*#__PURE__*/React.createElement("span", null, battle.battleId)), /*#__PURE__*/React.createElement("div", {
    className: styles.cell
  }, /*#__PURE__*/React.createElement("span", null, formatGameMode(battle.mode))), /*#__PURE__*/React.createElement("div", {
    className: styles.cell
  }, renderResult(battle.result, battle.rank, battle.mode)), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.cell, styles.rewards)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.gthc
  }, /*#__PURE__*/React.createElement("img", {
    src: icTHC,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, `+ ${battle.rewards.gTHC} THC`)), /*#__PURE__*/React.createElement("div", {
    className: styles.gpp
  }, /*#__PURE__*/React.createElement("img", {
    src: icGPP,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, `+ ${battle.rewards.gPP} PP`)), /*#__PURE__*/React.createElement("div", {
    className: styles.exp
  }, /*#__PURE__*/React.createElement("img", {
    src: icEXP,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, `+ ${battle.rewards.exp} exp`))), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.cell, styles.time)
  }, /*#__PURE__*/React.createElement("span", null, formatDateTimeByTimestamp(battle.timestamp))));
};

export default TableDesktopItem;